'use client'
import Style from "@/lib/style";
import Details from "@/lib/programContent";

type Props = {
  programName: string;
};

export default function GeneralDetails(props: Props) {
  const { programName } = props;
  const matchedStyle = Style.find(style => style.title === programName);
  const detail = Details[programName].details;

  return (
    <section className="relative mb-24">
      <div className={`${matchedStyle?.colors?.[0].buttonGradient} hidden md:block absolute -top-[30px] left-[50px] w-[650px] h-[400px] to-transparent opacity-10 rounded-r-[900px] filter blur-xl z-0`} />
      <div className="flex justify-center text-center relative mx-auto py-2 bigscreen-responsive md:justify-end md:text-left xl:mt-44 md:px-0">
        <div>
          <div className="pt-8 xl:absolute xl:-top-52 right-52">
            <div className="block relative xl:hidden">
              <img src="/images/chefsCursos.png" alt="Chefs" className="relative h-60 z-10 -left-8" />
            </div>
          </div>
          <div className="text-lg max-w-md px-8 mt-8 md:px-2 md:text-2xl md:max-w-3xl xl:max-w-lg xl:px-0 xl:py-0 xl:-mx-24" dangerouslySetInnerHTML={{ __html: detail.title(matchedStyle?.colors?.[0].textColor + ' font-bold') }} />
          <div className="font-thin max-w-sm text-xs py-4 px-8 md:px-2 md:text-lg md:max-w-3xl xl:max-w-xl xl:px-0 xl:py-4 xl:-mx-24" dangerouslySetInnerHTML={{ __html: detail.firstParagraph }} />
          <div className="font-thin max-w-sm text-xs py-4 px-8 md:px-2 md:text-lg md:max-w-3xl xl:max-w-xl xl:px-0 xl:py-4 xl:-mx-24" dangerouslySetInnerHTML={{ __html: detail.secondParagraph }} />
          <div className={`${matchedStyle?.colors?.[0].buttonGradient} block absolute bottom-0 left-0 transform w-full h-32 opacity-5 filter blur-lg xl:hidden`}/>
          <div className={`${matchedStyle?.colors?.[0].buttonGradient} block absolute bottom-0 right-0 transform w-full h-32 opacity-5 filter blur-lg xl:hidden`}/>
        </div>
        <div className="hidden absolute top-10 xl:block left-0">
          <img src="/images/chefsCursos.png" alt="Chefs" className="relative z-10 rounded-lg" />
        </div>
      </div>
    </section>
  );
}